import { Configuration, version } from './configuration';

export const env: Configuration = {
	url: 'https://app-bff-preparador-dev-we-001.azurewebsites.net',
	production: false,
	version
};
